import { Box, Flex, Icon, Text } from "@chakra-ui/react";
import { GetProgrammaticCampaignTopAccountsRO } from "@intentsify/dto";
import { Table } from "components";
import { MdAnalytics } from "react-icons/md";
import { getColumns } from "./TopAccounts.utils";

type TopAccountsTableProps = {
  isLoading: boolean;
  data: GetProgrammaticCampaignTopAccountsRO | undefined;
  hasVisits: boolean;
  hasConversions: boolean;
  hideSpendColumn?: boolean;
};

const TopAccountsTable = ({
  data,
  isLoading,
  hasVisits,
  hasConversions,
  hideSpendColumn,
}: TopAccountsTableProps) => {
  return (
    <Table
      variant="intentsifyClean"
      hidePagination={true}
      isControlledByAPI={false}
      isFetching={isLoading}
      data={data?.topAccounts ?? []}
      columns={getColumns(hasVisits, hasConversions, hideSpendColumn)}
      defaultPageSize={25}
      customNoData={
        <Flex alignItems="center" justifyContent="center" flex={1} py={6}>
          <Flex
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            maxW="250px"
          >
            <Box mt={1}>
              <Icon as={MdAnalytics} height="24px" width="24px" />
            </Box>
            <Box mt={1}>
              <Text fontWeight={500} fontSize="xs" textAlign="center">
                Currently there is no data available for the selected filters or
                visuals.
              </Text>
            </Box>
          </Flex>
        </Flex>
      }
    />
  );
};

export { TopAccountsTable };
